import axios from 'axios'
import {MedicalEnquiryItem, UploadFileResponse, UploadFilesParams} from '../types/medicalEnquiry'

const API_BASE_URL = process.env.REACT_APP_API_CLAIM_URL

export interface DownloadDocumentResponse {
  fileName: string
  contentType: string
  base64Data: string
}

export const fetchMedicalEnquiryList = async (
  claimNumber: string
): Promise<MedicalEnquiryItem[]> => {
  const response = await axios.get(`${API_BASE_URL}/api/MedicalEnquiry/ListByClaim/${claimNumber}`)
  return response.data
}

export const uploadMedicalEnquiryFiles = async (
  params: UploadFilesParams
): Promise<UploadFileResponse> => {
  const {idMe, claimNumber, username, files} = params

  const formData = new FormData()
  files.forEach((file) => {
    formData.append('files', file)
  })

  const response = await axios.post(
    `${API_BASE_URL}/api/MedicalEnquiry/UploadFiles?idMe=${idMe}&claimNumber=${claimNumber}&username=${encodeURIComponent(
      username
    )}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}

export const generateMedicalEnquiryDocument = async (
  claimNumber: string,
  idMe: number
): Promise<Blob> => {
  const response = await axios.get(
    `${API_BASE_URL}/api/MedicalEnquiry/GenerateDocument?claimNumber=${claimNumber}&idMe=${idMe}`,
    {
      responseType: 'blob',
    }
  )
  return response.data
}

export const downloadMedicalEnquiryDocument = async (
  claimNumber: string,
  fileName: string
): Promise<DownloadDocumentResponse> => {
  const response = await axios.get(
    `${API_BASE_URL}/api/MedicalEnquiry/DownloadDoc/${claimNumber}/${fileName}`
  )
  return response.data
}

export const deleteMedicalEnquiryDocument = async (
  claimNumber: string,
  idDoc: number,
  username: string
): Promise<{isSuccess: boolean; message: string}> => {
  const response = await axios.post(
    `${API_BASE_URL}/api/MedicalEnquiry/DeleteDocument?claimNumber=${claimNumber}&idDoc=${idDoc}&username=${encodeURIComponent(
      username
    )}`
  )
  return response.data
}

export const answerMedicalEnquiry = async (
  claimNumber: string,
  idMe: number,
  message: string,
  username: string
): Promise<{isSuccess: boolean; message: string}> => {
  const response = await axios.post(
    `${API_BASE_URL}/api/MedicalEnquiry/Reply?claimNumber=${claimNumber}&idMe=${idMe}&username=${encodeURIComponent(
      username
    )}`,
    {
      replyMessage: message,
    }
  )
  return response.data
}
